// Studby — route guard. Redirects to /login when not authenticated.
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sprout } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <Sprout className="text-accent animate-pulse" size={40} aria-hidden="true" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
